export const UPDATE_SIZE = 'updateSize';

export function updateSize(newSize) {
  return {
    type: UPDATE_SIZE,
    payload: newSize
  }
}
